module.exports = __webpack_public_path__ + "static/media/Checkbox.5642c47e.svg";